export function Arrow() {
  return (
    <div className="img_arrow">
      <img
        decoding="async"
        src="/images/solution/img_sec_arrow.svg"
        alt=""
        className="w-full"
      />
    </div>
  )
}
